import { getStateLChapters30Hours } from "./LChapters30Hours";
import { getStateLMapping } from "./stateLMapping";

// Helper function to find a chapter by its ID
function findChapterById(chapterId: string, stateName: string): any {
  const chapters = getStateLChapters30Hours(stateName);
  return chapters.find((ch: any) => ch.id === chapterId) || null;
}

// Helper function to create State standards from stateLMapping
function createStateStandards(stateName: string) {
  const stateMapping = getStateLMapping(stateName);

  if (!stateMapping) {
    return [];
  }

  return stateMapping.map((standardMapping) => {
    // Map chapters from the state mapping to full chapter objects from LChapters30Hours.ts
    const mappedChapters = standardMapping.chapters
      .map((chapterMapping) => {
        const fullChapter = findChapterById(chapterMapping.id, stateName);

        if (!fullChapter) {
          console.warn(
            `Chapter with ID "${chapterMapping.id}" not found in LChapters30Hours.ts for State "${stateName}" standard "${standardMapping.id}"`
          );
          return null;
        }

        // Use the title from the mapping (which has the correct chapter number)
        // but keep all other data from the full chapter
        return {
          id: fullChapter.id,
          title: chapterMapping.title, // Use title from mapping (has correct chapter number)
          audioUrl: fullChapter.audioUrl,
          standardId: fullChapter.standardId,
          description: fullChapter.description,
          content: fullChapter.content,
          synchronousContent: fullChapter.synchronousContent,
          reflections: fullChapter.reflections,
          learningObjectives: fullChapter.learningObjectives,
          readingTime: fullChapter.readingTime,
          skillBuilder: fullChapter.skillBuilder,
          comingSoon: false,
        };
      })
      .filter((chapter) => chapter !== null);

    return {
      id: standardMapping.id,
      title: standardMapping.title,
      overview: standardMapping.overview || "Add an overview from you",
      chapters: mappedChapters,
    };
  });
}

// Export the standards array
export const exported30Hours = [
  {
    stateName: "Oklahoma",
    standards: createStateStandards("Oklahoma"),
  },
  {
    stateName: "California",
    standards: createStateStandards("California"),
  },
  {
    stateName: "Alabama",
    standards: createStateStandards("Alabama"),
  },
  {
    stateName: "Colorado",
    standards: createStateStandards("Colorado"),
  },
  {
    stateName: "Connecticut",
    standards: createStateStandards("Connecticut"),
  },
  {
    stateName: "Delaware",
    standards: createStateStandards("Delaware"),
  },
  {
    stateName: "Florida",
    standards: createStateStandards("Florida"),
  },
  {
    stateName: "Georgia",
    standards: createStateStandards("Georgia"),
  },
  {
    stateName: "Illinois",
    standards: createStateStandards("Illinois"),
  },
  {
    stateName: "Indiana",
    standards: createStateStandards("Indiana"),
  },
  {
    stateName: "Iowa",
    standards: createStateStandards("Iowa"),
  },
  {
    stateName: "Kansas",
    standards: createStateStandards("Kansas"),
  },
  {
    stateName: "Kentucky",
    standards: createStateStandards("Kentucky"),
  },
  {
    stateName: "Louisiana",
    standards: createStateStandards("Louisiana"),
  },
  {
    stateName: "Maine",
    standards: createStateStandards("Maine"),
  },
  {
    stateName: "Maryland",
    standards: createStateStandards("Maryland"),
  },
  {
    stateName: "Michigan",
    standards: createStateStandards("Michigan"),
  },
  {
    stateName: "Minnesota",
    standards: createStateStandards("Minnesota"),
  },
  {
    stateName: "Mississippi",
    standards: createStateStandards("Mississippi"),
  },
  {
    stateName: "Missouri",
    standards: createStateStandards("Missouri"),
  },
  {
    stateName: "Nebraska",
    standards: createStateStandards("Nebraska"),
  },
  {
    stateName: "New Hampshire",
    standards: createStateStandards("New Hampshire"),
  },
  {
    stateName: "New Jersey",
    standards: createStateStandards("New Jersey"),
  },
  {
    stateName: "New York",
    standards: createStateStandards("New York"),
  },
  {
    stateName: "North Carolina",
    standards: createStateStandards("North Carolina"),
  },
  {
    stateName: "Ohio",
    standards: createStateStandards("Ohio"),
  },
  {
    stateName: "Oregon",
    standards: createStateStandards("Oregon"),
  },
  {
    stateName: "Pennsylvania",
    standards: createStateStandards("Pennsylvania"),
  },
  {
    stateName: "Rhode Island",
    standards: createStateStandards("Rhode Island"),
  },
  {
    stateName: "South Carolina",
    standards: createStateStandards("South Carolina"),
  },
  {
    stateName: "Tennessee",
    standards: createStateStandards("Tennessee"),
  },
  {
    stateName: "Texas",
    standards: createStateStandards("Texas"),
  },
  {
    stateName: "Texas PFLE",
    standards: createStateStandards("Texas PFLE"),
  },
  {
    stateName: "Utah",
    standards: createStateStandards("Utah"),
  },
  {
    stateName: "Virginia",
    standards: createStateStandards("Virginia"),
  },
  {
    stateName: "West Virginia",
    standards: createStateStandards("West Virginia"),
  },
  {
    stateName: "Wisconsin",
    standards: createStateStandards("Wisconsin"),
  },
];

export function getState30Hours(stateName: string) {
  return exported30Hours.find((standard) => standard.stateName === stateName)
    ?.standards;
}
